import {Box, Button, Stack} from '@mui/material';
import Icon from 'presentation/icons';
import {useMediaQueries} from 'presentation/pages';
import {translations} from 'presentation/translations-new';
import React, {useState} from 'react';
import {AlertInfo} from '../AlertInfo';
import {PhonesDrawer} from '../PhonesDrawer';
import {PhonesMenu} from '../PhonesMenu';
import {CallPhoneButtonProps} from './types';

const {call} = translations['pt-br'].commons;
const {choosePhoneNumber} = translations['pt-br'].privateFlow.bookingFlow.unitsFlow.unitDetails;

export const CallPhoneButton = ({phoneNumbers, phoneNumbersAlert}: CallPhoneButtonProps) => {
	const {isMobile} = useMediaQueries();
	const [openPhoneDrawerState, setOpenPhoneDrawerState] = useState<boolean>(false);
	const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);

	const phoneNumbersLenght = phoneNumbers?.length ?? 0;
	const hasMoreThanOnePhoneNumber = phoneNumbersLenght > 1;
	const shouldCallDirectlyToOnlyPhone = phoneNumbers && phoneNumbersLenght === 1 && isMobile;
	const shouldOpenPhoneDrawer = hasMoreThanOnePhoneNumber && isMobile;
	const isPhoneNumberMenuOpen = Boolean(anchorEl);

	const handleOpenPhoneMenu = (event: React.MouseEvent<HTMLButtonElement>) => {
		if (shouldCallDirectlyToOnlyPhone) {
			const phone = phoneNumbers[0];
			window.location.href = `tel:${phone}`;
			return;
		}

		if (shouldOpenPhoneDrawer) {
			setOpenPhoneDrawerState(true);
			return;
		}
		setAnchorEl(event.currentTarget);
	};

	const handleClosePhoneMenu = () => {
		setAnchorEl(null);
	};

	const handleTogglePhoneDrawer = () => {
		setOpenPhoneDrawerState(prev => !prev);
	};

	return (
		<Stack>
			<Button
				variant="outlined"
				size="large"
				fullWidth
				endIcon={<Icon name="phone-filled" size={24} />}
				onClick={handleOpenPhoneMenu}>
				{call}
			</Button>
			{isMobile ? (
				<PhonesDrawer.Root
					open={openPhoneDrawerState}
					toggleDrawer={handleTogglePhoneDrawer}
					title={choosePhoneNumber}>
					<AlertInfo.Root>{phoneNumbersAlert}</AlertInfo.Root>
					<PhonesDrawer.WithTitle phoneNumbers={phoneNumbers} />
				</PhonesDrawer.Root>
			) : (
				<PhonesMenu.Root
					open={isPhoneNumberMenuOpen}
					onClose={handleClosePhoneMenu}
					anchorEl={anchorEl}
					anchorOrigin={{
						vertical: 'top',
						horizontal: 'center',
					}}
					transformOrigin={{
						vertical: 'bottom',
						horizontal: 'center',
					}}>
					<Box px={2} py={1}>
						<AlertInfo.Root>{phoneNumbersAlert}</AlertInfo.Root>
					</Box>
					<PhonesMenu.WithTitle phoneNumbers={phoneNumbers} />
				</PhonesMenu.Root>
			)}
		</Stack>
	);
};
